import { UpdateDeviceAliasParams } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const updateDeviceAlias = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: UpdateDeviceAliasParams
}): Promise<AxiosResponse<void>> => {
  const { id, alias } = params
  return api.put<void>(`/devices/${id}/alias`, { alias })
}
